import React from "react";
import { CiImageOn } from "react-icons/ci";
import img1 from "../../../assets/imgby_artist1.png";
import img2 from "../../../assets/imgby_artist2.png";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/header/Header";

export const Participate = ({ data }) => {
  const navigate = useNavigate();
  const defaultData = {
    name: "Character Designer",
    description: "This is a sample sketch description provided by the user.",
    image1: img1,
    image2: img2,
  };

  const showData = data || defaultData;

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        {/* Header */}
        <Header title={"Contest"} showBack={true}/>
      </header>
      <div className="w-full bg-[#F7F7F7]">
        <div className="w-full max-w-[1164px] mx-auto flex flex-col items-center justify-center gap-12 lg:flex-row mt-9">
          {/* Left Side */}
          <div className="w-full lg:max-w-[446px] flex">
            <div className="w-full flex flex-col">
              <div className="w-full border border-border_color rounded-[14px] p-2 sm:p-4 mb-4">
                {/* Title */}
                <h2 className="text-start text-black text-[20px] font-bold font-grotesk">
                  Sketch Type
                </h2>

                {/* Show Name */}
                <div className="mt-2">
                  <p className="w-full px-[14px] py-2 bg-gray-100 border text-[#201D1D] text-[12px] font-medium font-grotesk border-border_color rounded-md">
                    {showData.name}
                  </p>
                </div>

                {/* Uploaded Images */}
                <h2 className="text-start text-black text-[20px] font-bold font-grotesk mt-3">
                  Uploaded Images
                </h2>

                <div className="w-full flex items-center justify-center gap-2 mt-2">
                  {/* First Image */}
                  <div className="relative flex-1 max-w-[200px] h-[174px]">
                    <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                      {showData.image1 ? (
                        <img src={showData.image1} alt="Preview 1" className="w-full h-full object-cover" />
                      ) : (
                        <CiImageOn className="text-8xl text-gray-300" />
                      )}
                    </div>
                  </div>

                  {/* Second Image */}
                  <div className="relative flex-1 max-w-[200px] h-[174px]">
                    <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                      {showData.image2 ? (
                        <img src={showData.image2} alt="Preview 2" className="w-full h-full object-cover" />
                      ) : (
                        <CiImageOn className="text-8xl text-gray-300" />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="w-full border border-border_color rounded-[14px] flex flex-col p-2 sm:p-4 items-center mt-4">
                <p className="w-full max-w-[750px] min-h-[150px] p-3 rounded-xl bg-gray-100 text-sm">
                  {showData.description}
                </p>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div onClick={() => navigate('/artist/comments-contests')} className="cursor-pointer w-full max-w-[666px] min-h-[572px] h-full flex items-center justify-center border border-dashed border-border_color rounded-[14px]">
            <div className="flex items-center justify-center flex-col">
              <p className="text-[16px] font-medium font-grotesk text-black mb-4">
                Result will be show with in
              </p>
              <h2 className="text-2xl sm:text-[42px] font-bold font-grotesk text-secondary">
                10 Days 12 Hours
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
